module.exports = __webpack_public_path__ + "img/tab_item01.3932f1c2.png";